import React, { useEffect, useRef, useState } from 'react';
import {
  Animated,
  Image,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  useWindowDimensions,
  View,
} from 'react-native';

import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { useTranslation } from 'react-i18next';

import {
  useNavigation
} from '@react-navigation/native';

import common_styles, {
  fonts,
  padding
} from '../../common/components/CommonStyles';
import Button from '../../common/components/Button';

import {
  Body2,
  ButtonText,
  SmallStringButton,
  Title,
  useAppWidth,
  VSkipHuge,
  VSkipLarge
} from '../../utils/';
import {
  ROOT_SCREENS
} from '../../common/constants/';
import { PageIndicator } from '../../utils/PageIndicator';
import { useTheme } from '../../utils/Theme';
import MaskView from '../../utils/MaskView';

import CurvyMask from '../../assets/CurvyMask';
import CurvyMask2 from '../../assets/CurvyMask2';
import CurvyMask3 from '../../assets/CurvyMask3';
import CircleBlob from '../../assets/CircleBlob';

import Image2 from '../../assets/green.webp';
import Image1 from '../../assets/potato.webp';
import Image0 from '../../assets/various.webp';

const OnboardingPage = ({
  imageSource,
  mask,
  label,
  labelPosition,
  title,
  body,
  button,
  showLabel = false,
}) => {
  const { bottom, top } = useSafeAreaInsets();

  const theme = useTheme();

  const { t } = useTranslation(['welcome', 'common']);

  const navigation = useNavigation();


  const { width: win_width } = useWindowDimensions();
  const [img_dims, setImgDims] = React.useState({ width: 0, height: 0, aspectRatio: 1.0 });
  const [img_src, setImgSrc] = React.useState(undefined);

  React.useEffect(() => {
    const resolved = Image.resolveAssetSource(imageSource);
    if (resolved && resolved.width && resolved.height) {
      setImgDims({
        width: resolved.width,
        height: resolved.height,
        aspectRatio: resolved.height / resolved.width,
      });
      setImgSrc(resolved.uri);
    }
  }, [imageSource]);

  const image_height = 1.42 * win_width * img_dims.aspectRatio;

  return (
    <View style={{flex: 1, flexDirection: 'column'}}>
      <View style={{width: win_width, height: image_height}}>
        <Image
          style={{width: '100%', height: '100%'}}
          source={imageSource}
        />
        {/*
        <MaskView
          mask={mask}
          image_src={img_src}
          style={{width: '100%', height: '100%', backgroundColor: 'green'}}
          width={win_width}
          height={image_height}
        />
        */}

        {
          (showLabel && label) ? (
            <View style={labelPosition}>
              <CircleBlob>
                <Text
                  style={{
                    ...fonts.handWritten,
                    color: 'white',
                    textAlign: 'center',
                    fontSize: 20,
                    transform: [{rotate: '-6.3deg'}]
                  }}
                  adjustsFontSizeToFit={true}
                  numberOfLines={1}
                >
                  {label}
                </Text>
              </CircleBlob>
            </View>
          ) : null
        }
      </View>
      <View style={{flex: 1, padding, paddingBottom: bottom + padding, justifyContent: 'flex-end'}}>
        <VSkipLarge/>
        <Title style={[theme.general]}>{title}</Title>
        <VSkipLarge/>
        <Body2 style={[theme.general]}>{body}</Body2>
        <VSkipHuge/>
        <View style={common_styles.buttonContainer}>
          {button}
        </View>
      </View>
    </View>
  );
};

const GettingStartedTour = ({}) => {
  const win_width = useWindowDimensions().width;
  const width = useAppWidth();
  const { bottom, top } = useSafeAreaInsets();

  const scroll_ref = useRef();
  const scroll_x = useRef(new Animated.Value(0)).current;
  const active_elem = useRef(Animated.divide(scroll_x, win_width)).current;

  const theme = useTheme();

  const { t } = useTranslation(['welcome', 'common']);

  const navigation = useNavigation();

  const animated = (Platform.OS !== 'web');  // Setting animated to true breaks 'scrollTo' on (iOS) Safari (in combination with scrollEnabled=false)

  const onRequestClose = () => {
    navigation.navigate(ROOT_SCREENS.app.name);
  }

  const pages = [
    (
      <OnboardingPage
        key={0}
        imageSource={Image0}
        mask={<CurvyMask/>}
        //label={t('gettingStartedPage1.label')}
        //labelPosition={{position: 'absolute', width: 80, height: 80, right: 50, bottom: -15}}
        title={t('gettingStartedPage1.title')}
        body={t('gettingStartedPage1.body')}
        button={
          <Button
            style={[common_styles.button, theme.button, {flex: 1}]}
            onPress={() => scroll_ref.current?.scrollTo({x: (0 + 1) * win_width, animated})}
          >
            <ButtonText style={theme.button}>
              { t('common:common.next') }
            </ButtonText>
          </Button>
        }
        t={t}
      />
    ),
    (
      <OnboardingPage
        key={1}
        imageSource={Image1}
        mask={<CurvyMask2/>}
        //label={t('gettingStartedPage2.label')}
        //labelPosition={{position: 'absolute', width: 100, height: 100, left: 20, bottom: 10}}
        title={t('gettingStartedPage2.title')}
        body={t('gettingStartedPage2.body')}
        button={
          <Button
            style={[common_styles.button, theme.button, {flex: 1}]}
            onPress={() => scroll_ref.current?.scrollTo({x: (1 + 1) * win_width, animated})}
          >
            <ButtonText style={theme.button}>
              { t('common:common.next') }
            </ButtonText>
          </Button>
        }
      />
    ),
    (
      <OnboardingPage
        key={2}
        imageSource={Image2}
        mask={<CurvyMask3/>}
        //label={t('gettingStartedPage3.label')}
        //labelPosition={{position: 'absolute', width: 80, height: 80, right: 30, bottom: -10}}
        title={t('gettingStartedPage3.title')}
        body={t('gettingStartedPage3.body')}
        button={
          <Button
            style={[common_styles.button, theme.button, {flex: 1}]}
            onPress={onRequestClose}
          >
            <ButtonText style={theme.button}>
              { t('getStarted') }
            </ButtonText>
          </Button>
        }
      />
    )
  ];

  return (
    <>
      <Animated.ScrollView
        ref={scroll_ref}
        horizontal={true}
        pagingEnabled={true}
        showsHorizontalScrollIndicator={false}
        bounces={false}
        onScroll={Animated.event([{ nativeEvent: { contentOffset: { x: scroll_x } } }], {
          useNativeDriver: true,
        })}
      >
        {
          pages.map((page, index) => (
            <View
              key={index}
              style={[
                {
                  height: '100%',
                  width: win_width,
                  flexDirection: 'row',
                  justifyContent: 'center'
                },
                theme.general
              ]}
            >
              { page }
            </View>
          ))
        }
      </Animated.ScrollView>
      <SmallStringButton
        onPress={onRequestClose}
        style={{position: 'absolute', top: top + padding, right: padding}}
        cta={t('common:common.skip')}
      />
      <View style={{alignItems: 'center', bottom}}>
        <PageIndicator
          count={pages.length}
          color={theme.general.color}
          current={active_elem}
        />
      </View>
    </>
  );
}

export default GettingStartedTour;
